module.exports = __webpack_public_path__ + "static/img/17059D_2_3_R_20200315_fit.d6aecc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17059D_2_3_R_20200315_fit.png
// module id = W8Fi
// module chunks = 0